import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { api } from "../../Constant";
import axios from "axios";

function FreeshippingBgimage() {
  const [shipping, setShipping] = useState([]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    axios
      .post(api + "ads_list")
      .then((response) => {
        if (response.data.success === "true") {
          setShipping(response.data.ads);
        } else {
          console.log("No ads found");
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }, []);

  const renderContent = (item) => (
    <div className="row" key={item.id || item.image}>
      <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 left_col">
        <div className="inner-box">
          <h1>{item.main_title}</h1>
          <h5>{item.title}</h5>
          <h1>
            <span>₹</span> 1500
          </h1>
        </div>
      </div>
      <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 right_col">
        <img src={item.image} style={{ width: "100%" }} alt="img" />
      </div>
    </div>
  );

  return (
    <section className="free_shipping_section pt-5">
      <div className="container">
        {shipping.length > 1 ? (
          <Slider {...settings}>
            {shipping.map((item) => renderContent(item))}
          </Slider>
        ) : (
          shipping.map((item) => renderContent(item))
        )}
      </div>
    </section>
  );
}

export default FreeshippingBgimage;
